<div class="container">
  <fgb-points-summary-bar [backButtonTitle]="'auctions.back.to' | translate"></fgb-points-summary-bar>
</div>

<div class="container d-none d-lg-block pt-3">
  <div class="back-btn text-white cursor-pointer" (click)="goBack()">
    <span class="material-icons"> arrow_back_ios </span>
  </div>
</div>

<fgbcl-auction-details [auctionId]="id"></fgbcl-auction-details>
